import { render, staticRenderFns } from "./NoSidebarLayout.vue?vue&type=template&id=789e4b9e"
import script from "./NoSidebarLayout.vue?vue&type=script&lang=ts"
export * from "./NoSidebarLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports